import React from 'react';
import { FilterIcon } from '../icons/Icons';
import { IconWithTooltip } from '../icons/IconWithTooltip';
import { MultiSelectWithIconButton } from '../inputfields/MultiSelectWithIconButton';

export function FilterSelector({ options, action, clearAll, activeFilters }) {

    const action2 = (filters) => {
        // console.log(filters);
        // setActiveFilters(filters);
        // saveToLocalStorage(tableName, 'activeFilters', filters)
        action(filters);
    }

    const clearAllObj = () => {
        return {
            value: "deleteAll",
            label: "Mindet töröl"
        }
    }


    return (
        <div className='filter-selector action-button'>
            <IconWithTooltip title="Szűrés">
                <MultiSelectWithIconButton
                    options={options}
                    initialOptionState={activeFilters}
                    action={action2}
                    clearAll={clearAll}
                    clearAllLabel={clearAllObj()}
                    icon={<FilterIcon />} />
            </IconWithTooltip>
        </div>
    )
}